import { SVGProps } from 'react'
const KeyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#4F4848"
      d="M1.548 2.04C3.62-.024 6.98-.024 9.036 2.04A5.285 5.285 0 0 1 10.36 7.36l3.29 3.289c.23.238.391.707.342 1.043l-.21 1.525c-.077.504-.546.98-1.05 1.05l-1.525.21c-.336.049-.805-.105-1.043-.35l-.574-.574a.346.346 0 0 1 0-.497l1.358-1.357a.528.528 0 0 0 0-.742.528.528 0 0 0-.742 0L8.841 12.32a.35.35 0 0 1-.49 0l-1.484-1.476a5.3 5.3 0 0 1-5.319-1.309 5.31 5.31 0 0 1 0-7.495ZM5.25 7.485a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
      opacity={0.6}
    />
  </svg>
)
export default KeyIcon
